const icons = {
  TypeScript: (
    <>
      <rect x="1.5" y="1.5" width="13" height="13" rx="2" stroke="currentColor" strokeWidth="1.3" fill="none"/>
      <path d="M5 6.5H11M8 6.5V11.5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"/>
    </>
  ),
  JavaScript: (
    <>
      <rect x="1.5" y="1.5" width="13" height="13" rx="2" stroke="currentColor" strokeWidth="1.3" fill="none"/>
      <path d="M9.5 5.5V10.5C9.5 11.8 8.5 12.5 7.5 12.5C6.5 12.5 5.8 12 5.5 11.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    </>
  ),
  Python: (
    <>
      <path d="M8 2C6.2 2 4.5 2.8 4.5 4.5V7H8V7.8H4C2.8 7.8 1.5 8.8 1.5 10.5C1.5 12.2 2.8 13 4 13H5V11.5C5 10 6.2 9 8 9" fill="none" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round"/>
      <path d="M8 2C9.8 2 11.5 2.8 11.5 4.5V7H8V7.8H12C13.2 7.8 14.5 8.8 14.5 10.5C14.5 12.2 13.2 13 12 13H11V11.5C11 10 9.8 9 8 9" fill="none" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round"/>
      <circle cx="6" cy="4.8" r="0.8" fill="currentColor"/>
      <circle cx="10" cy="10.2" r="0.8" fill="currentColor"/>
    </>
  ),
  'Node.js': (
    <>
      <path d="M8 1.5L13.5 4.75V11.25L8 14.5L2.5 11.25V4.75L8 1.5Z" fill="none" stroke="currentColor" strokeWidth="1.3"/>
      <circle cx="8" cy="8" r="1.5" fill="currentColor"/>
    </>
  ),
  React: (
    <>
      <ellipse cx="8" cy="8" rx="6.5" ry="2.5" fill="none" stroke="currentColor" strokeWidth="1.1"/>
      <ellipse cx="8" cy="8" rx="6.5" ry="2.5" fill="none" stroke="currentColor" strokeWidth="1.1" transform="rotate(60 8 8)"/>
      <ellipse cx="8" cy="8" rx="6.5" ry="2.5" fill="none" stroke="currentColor" strokeWidth="1.1" transform="rotate(120 8 8)"/>
      <circle cx="8" cy="8" r="1.4" fill="currentColor"/>
    </>
  ),
  'Next.js': (
    <>
      <path d="M8 1.5L14 12.5H2L8 1.5Z" fill="none" stroke="currentColor" strokeWidth="1.3" strokeLinejoin="round"/>
      <line x1="5.5" y1="9" x2="10.5" y2="9" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/>
    </>
  ),
  Angular: (
    <>
      <path d="M8 1.5L13.5 3.5L12 12L8 14.5L4 12L2.5 3.5L8 1.5Z" fill="none" stroke="currentColor" strokeWidth="1.2"/>
      <path d="M5.5 10.5L8 5L10.5 10.5M6.5 8.5H9.5" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
    </>
  ),
  NestJS: (
    <>
      <path d="M8 1.5L13 4.25V9.75L8 12.5L3 9.75V4.25L8 1.5Z" fill="none" stroke="currentColor" strokeWidth="1.2"/>
      <path d="M5.5 8.5C6 10 7 10.5 8 10.5C9.5 10.5 10.5 9.5 10.5 8C10.5 6.5 9.5 5.5 8 5.5" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/>
    </>
  ),
  FastAPI: (
    <path d="M10 1.5L4.5 9H8L6 14.5L11.5 7H8.5L10 1.5Z" fill="currentColor"/>
  ),
  Express: (
    <>
      <circle cx="8" cy="8" r="6.5" fill="none" stroke="currentColor" strokeWidth="1.2"/>
      <path d="M5 6H11M5 8H10M5 10H11" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/>
    </>
  ),
  REST: (
    <>
      <circle cx="8" cy="8" r="1.5" fill="currentColor"/>
      <circle cx="3" cy="5" r="1.3" fill="currentColor"/>
      <circle cx="13" cy="5" r="1.3" fill="currentColor"/>
      <circle cx="3" cy="11" r="1.3" fill="currentColor"/>
      <circle cx="13" cy="11" r="1.3" fill="currentColor"/>
      <path d="M4.2 5.8L6.8 7.2M9.2 7.2L11.8 5.8M4.2 10.2L6.8 8.8M9.2 8.8L11.8 10.2" stroke="currentColor" strokeWidth="0.9"/>
    </>
  ),
  GraphQL: (
    <>
      <path d="M8 1.5L13.5 4.75V11.25L8 14.5L2.5 11.25V4.75L8 1.5Z" fill="none" stroke="currentColor" strokeWidth="1"/>
      <circle cx="8" cy="1.5" r="1.1" fill="currentColor"/>
      <circle cx="13.5" cy="4.75" r="1.1" fill="currentColor"/>
      <circle cx="13.5" cy="11.25" r="1.1" fill="currentColor"/>
      <circle cx="8" cy="14.5" r="1.1" fill="currentColor"/>
      <circle cx="2.5" cy="11.25" r="1.1" fill="currentColor"/>
      <circle cx="2.5" cy="4.75" r="1.1" fill="currentColor"/>
      <circle cx="8" cy="8" r="1.1" fill="currentColor"/>
    </>
  ),
  Kafka: (
    <>
      <circle cx="8" cy="8" r="1.5" fill="currentColor"/>
      <circle cx="3" cy="4" r="1.3" fill="currentColor"/>
      <circle cx="13" cy="4" r="1.3" fill="currentColor"/>
      <circle cx="3" cy="12" r="1.3" fill="currentColor"/>
      <circle cx="13" cy="12" r="1.3" fill="currentColor"/>
      <path d="M6.8 7.2L4.2 5M9.2 7.2L11.8 5M6.8 8.8L4.2 11M9.2 8.8L11.8 11" stroke="currentColor" strokeWidth="1.1"/>
    </>
  ),
  MongoDB: (
    <>
      <path d="M8 2C8 2 11.5 5.5 11.5 9.5C11.5 12.5 9.8 14 8 14C6.2 14 4.5 12.5 4.5 9.5C4.5 5.5 8 2 8 2Z" fill="none" stroke="currentColor" strokeWidth="1.3"/>
      <line x1="8" y1="11" x2="8" y2="14" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round"/>
    </>
  ),
  PostgreSQL: (
    <>
      <circle cx="7.5" cy="6.5" r="4.5" fill="none" stroke="currentColor" strokeWidth="1.2"/>
      <path d="M10.8 4.2C11.8 3.5 13.2 3.8 13.2 5.5" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/>
      <path d="M7.5 11V14M6 14H9" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/>
    </>
  ),
  MySQL: (
    <>
      <ellipse cx="8" cy="4" rx="5" ry="2" fill="none" stroke="currentColor" strokeWidth="1.2"/>
      <path d="M3 4V12C3 13.1 5.2 14 8 14C10.8 14 13 13.1 13 12V4" fill="none" stroke="currentColor" strokeWidth="1.2"/>
      <path d="M3 8C3 9.1 5.2 10 8 10C10.8 10 13 9.1 13 8" fill="none" stroke="currentColor" strokeWidth="1.2"/>
    </>
  ),
  'SQL Server': (
    <>
      <ellipse cx="8" cy="3.5" rx="5" ry="1.8" fill="none" stroke="currentColor" strokeWidth="1.2"/>
      <path d="M3 3.5V12.5C3 13.4 5.2 14.3 8 14.3C10.8 14.3 13 13.4 13 12.5V3.5" fill="none" stroke="currentColor" strokeWidth="1.2"/>
      <path d="M3 7C3 7.9 5.2 8.8 8 8.8C10.8 8.8 13 7.9 13 7" fill="none" stroke="currentColor" strokeWidth="1.2"/>
      <path d="M3 10.5C3 11.4 5.2 12.3 8 12.3C10.8 12.3 13 11.4 13 10.5" fill="none" stroke="currentColor" strokeWidth="1.2"/>
    </>
  ),
  Redis: (
    <>
      <path d="M8 2V14M3.1 4.8L12.9 11.2M12.9 4.8L3.1 11.2" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/>
      <circle cx="8" cy="8" r="2" fill="currentColor"/>
    </>
  ),
  'AWS Cognito': (
    <>
      <circle cx="8" cy="5.5" r="2.5" fill="none" stroke="currentColor" strokeWidth="1.2"/>
      <path d="M3.5 14C3.5 11.2 5.5 9.5 8 9.5C10.5 9.5 12.5 11.2 12.5 14" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/>
    </>
  ),
  Lambda: (
    <path d="M3 13L6.5 6L8 9M8 9L10.5 13M8 9H12.5" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  ),
  EC2: (
    <>
      <rect x="2" y="3" width="12" height="3.5" rx="1" fill="none" stroke="currentColor" strokeWidth="1.2"/>
      <rect x="2" y="9.5" width="12" height="3.5" rx="1" fill="none" stroke="currentColor" strokeWidth="1.2"/>
      <circle cx="12.5" cy="4.75" r="0.8" fill="currentColor"/>
      <circle cx="12.5" cy="11.25" r="0.8" fill="currentColor"/>
      <line x1="8" y1="6.5" x2="8" y2="9.5" stroke="currentColor" strokeWidth="1" strokeDasharray="1.5 1.5"/>
    </>
  ),
  S3: (
    <>
      <path d="M3 10V13.5C3 13.8 3.4 14 3.5 14H12.5C12.8 14 13 13.8 13 13.5V10" fill="none" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round"/>
      <path d="M8 2V10M5 5L8 2L11 5" fill="none" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
    </>
  ),
  Docker: (
    <>
      <rect x="1.5" y="5.5" width="3" height="2" rx="0.4" fill="currentColor"/>
      <rect x="5.5" y="5.5" width="3" height="2" rx="0.4" fill="currentColor"/>
      <rect x="9.5" y="5.5" width="3" height="2" rx="0.4" fill="currentColor"/>
      <rect x="5.5" y="3" width="3" height="2" rx="0.4" fill="currentColor"/>
      <rect x="9.5" y="3" width="3" height="2" rx="0.4" fill="currentColor"/>
      <path d="M1 9.5C1.5 11 3 11.5 5 11.5H11.5C13 11.5 14.5 10.5 14.5 9C13.8 9 13.5 8.5 13.5 8" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round"/>
      <path d="M13.5 6.5C14.5 6.5 15 7.2 15 7.5" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round"/>
    </>
  ),
  'New Relic': (
    <path d="M1.5 12L5 6.5L8.5 10L11.5 4.5L14.5 7.5" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
  ),
  'Amazon Bedrock': (
    <>
      <path d="M8 2L14 5.5L8 9L2 5.5L8 2Z" fill="none" stroke="currentColor" strokeWidth="1.2"/>
      <path d="M2 9L8 12.5L14 9" fill="none" stroke="currentColor" strokeWidth="1.2"/>
      <path d="M2 11.5L8 15L14 11.5" fill="none" stroke="currentColor" strokeWidth="1.2"/>
    </>
  ),
  'RAG Pipelines': (
    <>
      <circle cx="6" cy="6.5" r="3.5" fill="none" stroke="currentColor" strokeWidth="1.2"/>
      <path d="M8.5 9L11 11.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
      <rect x="10.5" y="10.5" width="4" height="4.5" rx="0.8" fill="none" stroke="currentColor" strokeWidth="1.1"/>
      <path d="M11.5 12.5H13.5M11.5 13.5H13" stroke="currentColor" strokeWidth="0.9" strokeLinecap="round"/>
    </>
  ),
  RAG: (
    <>
      <circle cx="6" cy="6.5" r="3.5" fill="none" stroke="currentColor" strokeWidth="1.2"/>
      <path d="M8.5 9L11 11.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
      <rect x="10.5" y="10.5" width="4" height="4.5" rx="0.8" fill="none" stroke="currentColor" strokeWidth="1.1"/>
      <path d="M11.5 12.5H13.5M11.5 13.5H13" stroke="currentColor" strokeWidth="0.9" strokeLinecap="round"/>
    </>
  ),
  'OpenAI API': (
    <>
      <circle cx="8" cy="8" r="2.5" fill="none" stroke="currentColor" strokeWidth="1.2"/>
      <path d="M8 1.5C10.2 1.5 12.2 2.8 13.2 4.7" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/>
      <path d="M14.5 8C14.5 10.2 13.2 12.2 11.3 13.2" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/>
      <path d="M8 14.5C5.8 14.5 3.8 13.2 2.8 11.3" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/>
      <path d="M1.5 8C1.5 5.8 2.8 3.8 4.7 2.8" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/>
      <line x1="8" y1="1.5" x2="8" y2="5.5" stroke="currentColor" strokeWidth="1" strokeLinecap="round"/>
      <line x1="14.5" y1="8" x2="10.5" y2="8" stroke="currentColor" strokeWidth="1" strokeLinecap="round"/>
      <line x1="8" y1="14.5" x2="8" y2="10.5" stroke="currentColor" strokeWidth="1" strokeLinecap="round"/>
      <line x1="1.5" y1="8" x2="5.5" y2="8" stroke="currentColor" strokeWidth="1" strokeLinecap="round"/>
    </>
  ),
  'Anthropic API': (
    <path d="M4 14L8 2L12 14M6 10H10" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  ),
  Cursor: (
    <path d="M3.5 2L3.5 12.5L6.5 9.5L9 14L10.5 13.5L8 8.5L11.5 8.5L3.5 2Z" fill="currentColor"/>
  ),
  Claude: (
    <path d="M13.5 5.5C12 3 9.5 1.5 6.5 2C3.5 2.5 1.5 5 1.5 8C1.5 11 3.5 13.5 6.5 14C9.5 14.5 12 13 13.5 10.5" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/>
  ),
  Storybook: (
    <>
      <rect x="3" y="2" width="10" height="12" rx="1.5" fill="none" stroke="currentColor" strokeWidth="1.2"/>
      <line x1="3" y1="2" x2="3" y2="14" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/>
      <path d="M6 5.5H10M6 8H9.5" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round"/>
    </>
  ),
  CSS: (
    <>
      <path d="M2.5 2H13.5L12 14L8 15.5L4 14L2.5 2Z" fill="none" stroke="currentColor" strokeWidth="1.2"/>
      <path d="M5 6.5H11M5.5 9.5H10.5M6 12.5H10" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round"/>
    </>
  ),
  Mailchimp: (
    <>
      <rect x="2" y="4.5" width="12" height="8.5" rx="1.5" fill="none" stroke="currentColor" strokeWidth="1.2"/>
      <path d="M2 6.5L8 10.5L14 6.5" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinejoin="round"/>
    </>
  ),
  'Google OAuth': (
    <>
      <path d="M14 8H10M14 8C14 5.5 12 3 9 2.5C6 2 3 4 2 7C1 10 2.5 13 5.5 14C8.5 15 12 13.5 13.5 11" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/>
    </>
  ),
  AWS: (
    <>
      <path d="M4.5 10C3 10 1.5 8.5 1.5 7C1.5 5.5 3 4 4.5 4.2C5 2.8 6.3 2 7.8 2C9 2 10 2.6 10.7 3.7C11 3.5 11.5 3.5 12 3.5C13.5 3.5 14.5 4.8 14.5 6.3C14.5 7.8 13.5 9.5 12 10" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/>
      <path d="M5.5 13.5L8 15L10.5 13.5M8 9V15" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
    </>
  ),
  IAM: (
    <>
      <rect x="5" y="7.5" width="6" height="5.5" rx="1" fill="none" stroke="currentColor" strokeWidth="1.2"/>
      <path d="M6.5 7.5V5.5C6.5 4.1 9.5 4.1 9.5 5.5V7.5" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/>
      <circle cx="8" cy="10" r="1" fill="currentColor"/>
    </>
  ),
};

export default function TechIcon({ name, size = 14 }) {
  const icon = icons[name];
  if (!icon) return null;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ flexShrink: 0, display: 'block' }}
      aria-hidden="true"
    >
      {icon}
    </svg>
  );
}
